<template>
  <v-dialog v-model="dialog_value.show_dialog" max-width="700px"
            @click:outside="$store.commit('close_change_submitter_dialog')">
    <v-card>
      <v-toolbar flat color="secondary" dark class="justify-center">
        <v-toolbar-title>تغییر دانش آموز</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-2 pb-0">


        <!-- search new phone_number -->

        <validation-observer v-slot="{ invalid }">
          <v-col class="col-sm-6 col-12 pb-0">
            <p>شماره ی متناظر با حساب کاربری مورد نظر را وارد کنید</p>
            <validation-provider
                v-slot="{ errors }"
                rules="phone_number|required"
            >
              <v-text-field
                  required
                  outlined
                  label="شماره تلفن"
                  v-model="phone_number"
                  :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col class="col-sm-6 col-12">
            <div>
              <v-btn
                  block
                  depressed
                  disabled v-if="search_loading">
                <v-progress-circular
                    indeterminate
                    color="primary"
                >
                </v-progress-circular>
              </v-btn>

              <v-btn
                  v-else
                  block
                  color="secondary"
                  depressed
                  @click="$store.dispatch('search_account' , {'phone_number' : '+98'+ phone_number.slice(1)})"
                  :disabled="invalid || change_loading">
                جست و جو
              </v-btn>
            </div>
          </v-col>
        </validation-observer>


        <v-row v-if="dialog_value.show_search_result">
          <div class="text-center" v-if="search_loading">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
          </div>
          <v-col v-else>
            <div v-if="dialog_value.account == null">
              کاربری با این شماره یافت نشد
            </div>
            <div v-else>
              <v-card outlined color="gray">
                <v-container>
                  <p>نام : {{ dialog_value.account.full_name }}</p>
                  <p>کد ملی : {{ dialog_value.account.national_code }}</p>
                  <p>شماره همراه :
                    {{ dialog_value.account.phone }} </p>
                  <v-btn block
                  @click="$store.dispatch('change_submitter_admin')">
                    تغییر به این حساب کاربری
                  </v-btn>
                </v-container>
              </v-card>
            </div>
          </v-col>
        </v-row>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" outlined @click="$store.commit('close_change_submitter_dialog')">
          بستن
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import {mapState} from "vuex";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "vee-validate/dist/rules";

extend('phone_number', {
  validate: value => {
    return value.length === 11 && /^09[0-9]{9}$/.test(value);
  },
  message: 'شماره تلفن همراه باید 11 رقمی باشد.'
});

extend("required", {
  ...required,
  message: "پر کردن این قسمت اجباریست",
});

export default {
  name: "ChangeSubmitterDialog",
  computed: {
    ...mapState({
      dialog_value: state => state.Admin.settings.change_submitter_dialog,
      search_loading: state => state.Admin.settings.change_submitter_dialog.loading_search,
      change_loading: state => state.Admin.settings.change_submitter_dialog.loading_change,

    }),
  },
  data: () => {
    return {
      phone_number: "",
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider
  }
}
</script>

<style scoped>

</style>